// Shared marketing-site nav. The original bedd.dev pages each shipped their
// own copy of this block (one variant per page with `.active` flipped to the
// current link); this helper collapses them into a single string so every
// marketing page renders the exact same nav contract.
//
// Internal hrefs are SPA paths (react-router picks them up after the browser
// navigation). The logo always points home. Sign-in/up are the only auth
// affordances; the original bedd.dev pricing/catalogue/individual/business
// pages shipped a vague `Login` button — we replace that with the same
// `Sign in` + `Get started` pair the landing page already uses, for parity.

export type MarketingNavActive =
  | 'home'
  | 'individual'
  | 'business'
  | 'catalogue'
  | 'pricing';

const LINKS: ReadonlyArray<{ active: MarketingNavActive; href: string; label: string }> = [
  { active: 'individual', href: '/individual', label: 'For Individual' },
  { active: 'business', href: '/business', label: 'For Business' },
  { active: 'catalogue', href: '/catalogue', label: 'Catalogue' },
  { active: 'pricing', href: '/pricing', label: 'Pricing' },
];

export function navMarkup(active: MarketingNavActive): string {
  const items = LINKS.map(({ active: key, href, label }) => {
    const cls = key === active ? ' class="active"' : '';
    return `      <li><a href="${href}" data-spa-link${cls}>${label}</a></li>`;
  }).join('\n');

  return `<nav class="site-nav" id="main-nav">
  <div class="nav-inner">
    <a href="/" data-spa-link class="nav-logo">BIMAssess</a>
    <ul class="nav-links">
${items}
    </ul>
    <div class="nav-cta-group">
      <a href="/sign-in" data-spa-link class="login">Sign in</a>
      <a href="/sign-up" data-spa-link class="btn btn-primary">Get started</a>
    </div>
  </div>
</nav>`;
}
